import  ApiService  from '../../services/api.service';
import {TokenService} from "../../services/storage.service";
const state= {
    dealerServiceList: [],
    searchZipCode: '',
    loading: false,
    dealerDetails: [],
    dealerDetailsLoading: false,
    strAddress: '',
    strAddressWS: '',
    tempAddress: null,
    ctPlaceResultData : null,
    dealerServiceApiParamsCached: [],
    dealerServiceApiParamsCachedWS: [],
    isShowEmptyDealerMessage : false
}
const getters= {
    dealerServiceList: (state) => {
        return state.dealerServiceList;
    },
    loading: (state) => state.loading,
    dealerDetails:  (state) => {
        return state.dealerDetails;
    },
    dealerDetailsLoading: (state) => state.loading,
    searchZipCode: (state) => state.searchZipCode,
    strAddress: (state) => state.strAddress,
    strAddressWS: (state) => state.strAddressWS,
    getTempAddress:  (state) => state.tempAddress,
    dealerServiceApiParamsCached: (state) => state.dealerServiceApiParamsCached,
    dealerServiceApiParamsCachedWS: (state) => state.dealerServiceApiParamsCachedWS,
    ctPlaceResultData: (state) => state.ctPlaceResultData,
    isShowEmptyDealerMessage: (state) => state.isShowEmptyDealerMessage
}
const actions= {
    async fetchDealerServices({commit}, params) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            const token = TokenService.getToken();
            const anonymousId = TokenService.getGuestToken();
            if(!token && !anonymousId) {
                return;
            }
            if (anonymousId) {
                params = params + '&anonymous_id=' + anonymousId;
            }

            ApiService.get('/dealers?'+params)
            .then(response => {
                commit('setDealerServiceList', response.data)
                resolve()
            })
            .catch(error => {
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false)
            })
        })
    },
    fetchDealerDetails({commit},dealerId) {
        commit('setDealerDetailsLoading', true)
        return new Promise((resolve, reject) => {
            ApiService.get('/dealer/'+dealerId+'/details?with=["timeSlots","workingDays"]')
            .then(response => {
                commit('setDealerDetails', response.data)
                commit('setShowEmptyDealerMessage', response.data.length === 0 ? true : false)
                resolve()
            })
            .catch(error => {
                reject(error);
            })
            .finally(() => {
                commit('setDealerDetailsLoading', false)
            })
        })
    },
    setSearchedZipcode({commit}, zipcode) {
        commit('setSearchZipcode', zipcode)
    },
    setDealerServicesList({commit}) {
        commit('setDealerServiceList', [])
    },
    setStrAddress({commit}, value) {
        commit('setStateStrAddress', value)
    },
    setStrAddressWS({commit}, value) {
        commit('setStateStrAddressWS', value)
    },
    setTempAddress({commit}, value) {
        commit('setStateTempAddress', value)
    },
    setDealerServiceApiParamsCached({commit}, value) {
        commit('setStateDealerServiceApiParamsCached', value)
    },
    setDealerServiceApiParamsCachedWS({commit}, value) {
        commit('setStateDealerServiceApiParamsCachedWS', value)
    },
    setCtPlaceResultData({commit}, value) {
        commit('setCtPlaceResultData', value)
    },
    setShowEmptyDealerMessage({commit}, value) {
        commit('setShowEmptyDealerMessage', value)
    }
}
const mutations= {
    setLoading(state, status) {
        state.loading = status
    },
    setDealerServiceList(state, services) {
        var servicePoint = null;
        if ("SearchedSelectedServicePoint" in localStorage) {
            servicePoint = JSON.parse(localStorage.getItem("SearchedSelectedServicePoint"))
        } else if ("dealerservice" in localStorage) {
            servicePoint = JSON.parse(localStorage.getItem("dealerservice"))
        }
        if (servicePoint != null) {
            var selectedServicePoint = services.find(item => item.dealer_id === servicePoint.dealer_id)
            if (selectedServicePoint) {
                var selectedServicePointIndex = services.indexOf(selectedServicePoint)
                services.splice(selectedServicePointIndex, 1);
                services.unshift(selectedServicePoint)
            }
        }
        state.dealerServiceList = services
    },
    setDealerDetailsLoading(state, status) {
        state.dealerDetailsLoading = status
    },
    setDealerDetails(state, details) {
        state.dealerDetails = details
    },
    setSearchZipcode(state, zipcode) {
        state.searchZipCode = zipcode
    },
    setStateStrAddress(state, value) {
        state.strAddress = value
    },
    setStateStrAddressWS(state, value) {
        state.strAddressWS = value
    },
    setStateTempAddress(state, value) {
        state.tempAddress = value
    },
    setStateDealerServiceApiParamsCached(state, params) {
        state.dealerServiceApiParamsCached = params
    },
    setStateDealerServiceApiParamsCachedWS(state, params) {
        state.dealerServiceApiParamsCachedWS = params
    },
    setCtPlaceResultData(state, value) {
        state.ctPlaceResultData = value
    },
    setShowEmptyDealerMessage(state, value) {
        state.isShowEmptyDealerMessage = value
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}